import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
import { useQuery } from 'react-query';

var fetchPost = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.get('/api/rest/post/1'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPost() {
    return _ref.apply(this, arguments);
  };
}();

var ReactQueryApi = function ReactQueryApi() {
  var _useQuery = useQuery('post-1', function () {
    return fetchPost();
  }, {}),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      error = _useQuery.error;

  return _jsx("div", {
    children: JSON.stringify(data)
  });
};

export var DemoApiSection = function DemoApiSection() {
  return _jsx("div", {
    children: _jsx(ReactQueryApi, {})
  });
};